import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import './index.scss';
import { loginRequest } from 'redux/modules/user';
import { clientIsValidRedir, userIsNotAuthenticatedRedir } from 'hocs/auth';
import { currentClientSelector } from 'redux/selectors';

import { parseQueryString } from 'utils/helpers';
import { noop } from 'utils/helpers';
import { PageContainer, LoginForm } from 'smart-components';
import { PageContent } from 'components';
import { withClientId } from 'hocs';
import tr from '../../config/string-resources';
import { SubmissionError } from 'redux-form';

const COMPONENT_CSS_CLASSNAME = 'login-page';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

class LoginContainer extends Component {
	state = {
		showTOTPInput: false,
	};

	static defaultProps = {
		loginRequest: noop,
	};

	static propTypes = {
		clientId: PropTypes.string,
		loginRequest: PropTypes.func,
	};

	handleLoginFormSubmit = data => {
		const { clientId, loginRequest } = this.props;

		return this.formSubmit(loginRequest, {
			...data,
			clientId,
		});
	};

	formSubmit = (actionCreator, payload) => {
		payload.totp = payload.hasOwnProperty('totp') ? payload.totp : '';

		return new Promise((resolve, reject) => {
			actionCreator(payload, {
				onSuccess: resolve,
				onFail: reject,
			});
		}).catch(error => {
			const { data: payload } = error;

			if (payload.message === 'TOTP code required') {
				this.setState(
					{
						showTOTPInput: true,
					},
					function() {},
				);
				this.state.showTOTPInput = true;
			} else {
				const fieldErrors = payload.errors
					? payload.errors.reduce((acc, error) => {
							acc[error.field] = tr(error.issue);
							return acc;
					  }, {})
					: {};
				throw new SubmissionError({
					_error: payload.message,
					...fieldErrors,
				});
			}
		});
	};

	render() {
		const { client, location } = this.props;
		const params = parseQueryString(location.search);
		const codeState = params.redirect.split('?').pop();
		const newParams = parseQueryString(codeState);
		if (newParams.state) {
			window.location.href =
				'https://' +
				newParams.state +
				'.app.unifi.id/operators?' +
				codeState;
		}
		const image = get(client, 'image');
		return (
			<PageContainer className={COMPONENT_CSS_CLASSNAME}>
				<PageContent>
					<PageContent.Main>
						<div className={bemE('form')}>
							{image && (
								<img
									className={bemE('logo')}
									src={`data:${image.mimeType};base64,${image.data}`}
									alt={client.displayName}
								/>
							)}
							<h1 className={bemE('title')}>Sign In</h1>
							<LoginForm
								onSubmit={this.handleLoginFormSubmit}
								showTOTPInput={this.state.showTOTPInput}
							/>
						</div>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

const selector = createStructuredSelector({
	client: currentClientSelector,
});

export const actions = {
	loginRequest,
};

export default compose(
	clientIsValidRedir,
	userIsNotAuthenticatedRedir,
	withClientId,
	connect(selector, actions),
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/pages/login/index.js